<template>
  <div class="ip-detect">
    <h3>IP fetch</h3>
    <div v-if="loading">Loading...</div>
    <div v-else>
      <input type="text" v-model="ipv4" readonly>
      <el-button type="primary" @click="copyIp">Copy</el-button>
    </div>
  </div>
</template>
<script>
import axios from 'axios';

export default {
    data() {
        return {
            ipv4: '',
            loading: true
        };
    },
    mounted() {
        this.fetchIp();
    },
    methods: {
        copyIp() {
            navigator.clipboard.writeText(this.ipv4).then().catch(err => console.error(err))
        },
        fetchIp() {
            axios.get('https://api.ipify.org?format=json').then(response => {
                this.ipv4 = response.data.ip;
                this.loading = false;
            }).catch(error => {
                console.error('Error fetching IP address:', error);
                this.loading = false;
            });
        }
    }

}
</script>
<style scoped>
.ip-detect {
  text-align: center;
  margin-top: 50px;
}
</style>
